module.exports = __webpack_public_path__ + "static/media/oven.29746ca8.svg";